import EN from "../locales/en";

export const FUEL_TYPE = {
  ELECGAS: "elecgas",
  ELEC: "elec",
  GAS: "gas",
};

export const SUPPLIER_FUEL_TYPE = {
  ELECGAS: "electricitygas",
  ELEC: "electricity",
  GAS: "gas",
};

export const normaliseFuelType = (fuelType) => {
  const lowerFuelType = fuelType.toLowerCase();
  if (
    lowerFuelType === SUPPLIER_FUEL_TYPE.ELECGAS ||
    lowerFuelType === FUEL_TYPE.ELECGAS
  ) {
    return SUPPLIER_FUEL_TYPE.ELECGAS;
  } else if (
    lowerFuelType === FUEL_TYPE.ELEC ||
    lowerFuelType === SUPPLIER_FUEL_TYPE.ELEC
  ) {
    return SUPPLIER_FUEL_TYPE.ELEC;
  } else if (
    lowerFuelType === FUEL_TYPE.GAS ||
    lowerFuelType === SUPPLIER_FUEL_TYPE.GAS
  ) {
    return SUPPLIER_FUEL_TYPE.GAS;
  }
};

export const normaliseMeterType = (meterType) => {
  if (!meterType) return null;
  return meterType.replace("-SMART", "");
};

export const SAME_SUPPLIER = {
  SINGLE: "single",
  SEPARATE: "separate",
};

export const SAME_TARIFF = {
  YES: "yes",
  NO: "no",
};

// from https://apidocs.perse.io/#d0011fe7-7c37-4a48-a7d4-22cca8c26742
export const REQUIRED_TARIFF_FIELDS = {
  [FUEL_TYPE.ELECGAS]: [
    "dnoArea",
    "fuelType",
    "existingSupplieIdElec",
    "existingTariffIdElec",
    "existingkWhsElec",
    "existingSupplieIdGas",
    "existingTariffIdGas",
    "existingkWhsGas",
    "meterTypeElec",
  ],
  [FUEL_TYPE.ELEC]: [
    "dnoArea",
    "fuelType",
    "existingSupplieIdElec",
    "existingTariffIdElec",
    "existingkWhsElec",
    "meterTypeElec",
  ],
  [FUEL_TYPE.GAS]: [
    "dnoArea",
    "fuelType",
    "existingSupplieIdGas",
    "existingTariffIdGas",
    "existingkWhsGas",
  ],
};

export const paymentTypeOptions = [
  {
    value: EN.edit_tariff_form.payment.options.receipt,
    label: EN.edit_tariff_form.payment.options.receipt,
  },
  {
    value: EN.edit_tariff_form.payment.options.direct_debit,
    label: EN.edit_tariff_form.payment.options.direct_debit,
  },
  {
    value: EN.edit_tariff_form.payment.options.prepayment,
    label: EN.edit_tariff_form.payment.options.prepayment,
  },
];

export const elecMeterTypeOptions = [
  {
    value:
      EN.edit_tariff_form.meters.electricity.options.traditional_smart.value,
    label:
      EN.edit_tariff_form.meters.electricity.options.traditional_smart.label,
  },
  {
    value: EN.edit_tariff_form.meters.electricity.options.economy7_smart.value,
    label: EN.edit_tariff_form.meters.electricity.options.economy7_smart.label,
  },
  {
    value: EN.edit_tariff_form.meters.electricity.options.traditional.value,
    label: EN.edit_tariff_form.meters.electricity.options.traditional.label,
  },
  {
    value: EN.edit_tariff_form.meters.electricity.options.economy7.value,
    label: EN.edit_tariff_form.meters.electricity.options.economy7.label,
  },
];

export const gasMeterTypeOptions = [
  {
    value:
      EN.edit_tariff_form.meters.electricity.options.traditional_smart.value,
    label:
      EN.edit_tariff_form.meters.electricity.options.traditional_smart.label,
  },
  {
    value: EN.edit_tariff_form.meters.electricity.options.traditional.value,
    label: EN.edit_tariff_form.meters.electricity.options.traditional.label,
  },
];
